import { render, staticRenderFns } from "./AppReviewContainer.vue?vue&type=template&id=0d569b61&scoped=true&"
import script from "./AppReviewContainer.vue?vue&type=script&lang=ts&"
export * from "./AppReviewContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AppReviewContainer.vue?vue&type=style&index=0&id=0d569b61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d569b61",
  null
  
)

export default component.exports